import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { LabelWithControl } from "components/common/LabelControl";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";

export const IndividualHeader = ({ items, setAmendItems }) => {
  const [dialog, setDialog] = useState(false);
  const [poComment, setPOComment] = useState(items[0].originalComments || "");
  const [poOrderDate, setPOOrderDate] = useState(dayjs(items[0].orderDate));
  const [poDeliveryDate, setPODeliveryDate] = useState(
    dayjs(items[0].deliveryDate)
  );

  const openComments = () => {
    setDialog(true);
  };

  const closeComments = () => setDialog(false);

  const handleCommentChange = (event) => {
    setPOComment(event.target.value);
  };

  const handleSave = () => {
    closeComments();
    if (poComment !== "") {
      setAmendItems((prevItems) => {
        const updatedItems = prevItems.map((item) => ({
          ...item,
          comments: poComment,
        }));

        return JSON.stringify(updatedItems) !== JSON.stringify(prevItems)
          ? updatedItems
          : prevItems;
      });
    }
  };

  useEffect(() => {
    if (items && poOrderDate && poDeliveryDate) {
      setAmendItems((prevItems) => {
        const updatedItems = prevItems.map((item) => ({
          ...item,
          orderDate: poOrderDate.format("YYYY-MM-DDTHH:mm:ss"),
          deliveryDate: poDeliveryDate.format("YYYY-MM-DDTHH:mm:ss"),
        }));

        return JSON.stringify(updatedItems) !== JSON.stringify(prevItems)
          ? updatedItems
          : prevItems;
      });
    }
  }, [poOrderDate, poDeliveryDate, items]); //eslint-disable-line react-hooks/exhaustive-deps
  return (
    <>
      <Grid container spacing={1} key={items[0].poIdentifier}>
        <Grid item xs={12} sm={6} md={3} className="ptPO0">
          <Box
            sx={{
              display: {
                xs: "block",
                sm: "block",
                md: "none",
              },
            }}
          >
            <LabelWithControl label="PO Identifier" />
          </Box>
          <Typography>{items[0].poIdentifier}</Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={2} className="ptPO0">
          <Box
            sx={{
              display: {
                xs: "block",
                sm: "block",
                md: "none",
              },
            }}
          >
            <LabelWithControl label="Order Date" />
          </Box>
          <DatePicker
            format="YYYY/MM/DD"
            value={poOrderDate}
            onChange={setPOOrderDate}
            disablePast
            disabled={items[0].orderId}
            slotProps={{ 
              textField: { 
                size: "small",
                inputProps: { 'data-testid': 'order-date-input' }, 
              } 
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2} className="ptPO0">
          <Box
            sx={{
              display: {
                xs: "block",
                sm: "block",
                md: "none",
              },
            }}
          >
            <LabelWithControl label="Delivery Date" />
          </Box>
          <DatePicker
            format="YYYY/MM/DD"
            value={poDeliveryDate}
            onChange={setPODeliveryDate}
            disablePast
            slotProps={{ 
              textField: { 
                size: "small",
                inputProps: { 'data-testid': 'delivery-date-input' }, 
              } 
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={1} className="ptPO0">
          <Box
            sx={{
              display: {
                xs: "block",
                sm: "block",
                md: "none",
              },
            }}
          >
            <LabelWithControl label="Total Cases" />
          </Box>
          <Typography>{items[0].totalCases}</Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={1} className="ptPO0">
          <Box
            sx={{
              display: {
                xs: "block",
                sm: "block",
                md: "none",
              },
            }}
          >
            <LabelWithControl label="Total Pallets" />
          </Box>
          <Typography>{items[0].totalPallets}</Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={1} className="ptPO0">
          <Box
            sx={{
              display: {
                xs: "block",
                sm: "block",
                md: "none",
              },
            }}
          >
            <LabelWithControl label="Total Bases" />
          </Box>
          <Typography>{items[0].totalBases}</Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={1} className="ptPO0">
          <Box
            sx={{
              display: {
                xs: "block",
                sm: "block",
                md: "none",
              },
            }}
          >
            <LabelWithControl label="Total Wagons" />
          </Box>
          <Typography>{items[0].totalWagons}</Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={1} className="ptPO0">
          <Box
            sx={{
              display: {
                xs: "block",
                sm: "block",
                md: "none",
              },
            }}
          >
            <LabelWithControl label="Comments" />
          </Box>
          <Button onClick={openComments} className="linkButton">
            {!items[0].originalComments && poComment === "" ? "Add" : "Update"}
          </Button>
        </Grid>
      </Grid>

      <Dialog open={dialog} onClose={closeComments}>
        <div className="dialogStyling">
          <DialogTitle>Comments</DialogTitle>
          <DialogContent>
            <TextField
              multiline
              rows={4}
              variant="outlined"
              fullWidth
              placeholder="Enter comments..."
              value={poComment}
              onChange={handleCommentChange}
            />
          </DialogContent>
          <DialogActions>
            <Button
              className="commonPOButtons"
              variant="contained"
              onClick={handleSave}
              color="primary"
            >
              Save
            </Button>
          </DialogActions>
        </div>
      </Dialog>
    </>
  );
};
